/** Resolve only positive user IDs; API reservation ownership takes precedence. */
export function resolveKardexUserId(owner:unknown,requested:unknown):string|null {
 const valid=(value:unknown)=>{const n=Number(value);return Number.isInteger(n)&&n>0?String(n):null;};
 return valid(owner)||valid(requested);
}
export const kardexClientRoute=(id:string|null)=>id?`/kardex-citas/detalle/${id}`:'/kardex-citas';
